module.exports = __webpack_public_path__ + "img/logoInfo.9f5bf597.png";